import { render, staticRenderFns } from "./SelectBrand.vue?vue&type=template&id=510b7572&scoped=true"
import script from "./SelectBrand.vue?vue&type=script&lang=js"
export * from "./SelectBrand.vue?vue&type=script&lang=js"
import style0 from "./SelectBrand.vue?vue&type=style&index=0&id=510b7572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510b7572",
  null
  
)

export default component.exports